/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/platformLabelInput.scss';

import React from 'react';
import {AwesomeIcon, ChangeFunction, ElementPosition, OrnamentShape} from '@dvrd/dvr-controls';
import {BolmateInput} from "../index";

interface Props {
    onChange: ChangeFunction<string>;
    value: string;
    placeholder?: string;
    className?: string;
    label?: string;
    ornament?: OrnamentShape;
    disabled?: boolean;
}

export default function PlatformLabelInput(props: Props) {
    const {placeholder, onChange, value, className, disabled} = props,
        label = props.label ?? 'Herkenbare naam',
        ornament = props.ornament ?? {
            element: <div className='platform-label-info-container'>
                <AwesomeIcon name='info-circle' className='info-icon'/>
                <p className='platform-label-info'>Met deze naam kun je je accounts uit elkaar houden. Voeg bijvoorbeeld
                    BE toe als het gaat om een Belgisch verkoopaccount. Deze naam wordt enkel op het Bolmate platform
                    getoond om te wisselen tussen je verkoopaccounts en wordt dus niet gebruikt in de communicatie naar
                    je klanten.</p>
            </div>, placement: ElementPosition.RIGHT
        };

    return (
        <BolmateInput onChange={onChange} value={value} label={label} disabled={disabled}
                      inputProps={placeholder ? {placeholder} : undefined} ornaments={ornament}/>
    )
}